<template>
  <v-app>
    <the-top-navbar />
    <router-view></router-view>
  </v-app>
</template>

<script>
import TheTopNavbar from './components/Layout/TheTopNavbar.vue'
export default {
  components: {
    TheTopNavbar
  }
}
</script>
<style lang="scss">

html {
  font-size: 1em;
}

a {
  text-decoration: none;
}
a:focus-visible {
  position: relative;
  background-color: #fd0;
  color: black !important;
}
a:-moz-focusring {
  position: relative;
  background-color: #fd0;
  color: black !important;
}

.topnavbar-link:focus-visible {
  color: black !important;
}

.topnavbar-link:-moz-focusring {
  color: black !important;
}

.theme--dark.v-btn:focus::before {
  opacity: 0;
}

.v-input__slot {
  border-width: 4px 4px 4px 4px;
border-color: white;
border-style: solid; 
}

.v-tab:focus::before {
  opacity: 1.0 !important;
  background: transparent;
  border-width: 4px 4px 4px 4px;
border-color: #fd0;
border-style: solid; 
}

.v-tab:focus {
  
  background: #fd0;
 
  color: black !important;
}

.v-input--is-focused .v-input__slot {
  border-width: 4px 4px 4px 4px;
border-color: #fd0 !important;
border-style: solid; 
}

.theme--light.v-btn:focus::before {
  opacity: 0;
}

.v-btn:not(.v-btn--text):not(.v-btn--outlined):focus:before {
  opacity: 0;
}

button:focus-visible {
  position: relative;
  background-color: #fd0 !important;
  color: black !important;
}

button:-moz-focusring {
  position: relative;
  background-color: #fd0 !important;
  color: black !important;
}

button:focus-visible svg path {
  stroke: white;
}

button:-moz-focusring svg path {
  stroke: white;
}

.toolbar-link {
  cursor: pointer;
}

span:focus,
div:focus {
  outline: 0 !important;
}

::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); */
  border-radius: 0px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  border-radius: 0px;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
  background-color: rgb(161, 161, 161);
}
</style>
